import { render, staticRenderFns } from "./ScriptLoader.vue?vue&type=template&id=2d545293"
import script from "./ScriptLoader.vue?vue&type=script&lang=js"
export * from "./ScriptLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports